import styled from 'styled-components'

export const StyledMapLabel = styled.div`
  font-family: 'Manrope, sans-serif';
  position: relative;
  text-align: center;
  text-transform: capitalize;
  line-height: 1rem;
  bottom: 0;
  left: 0;
  border-radius: 8px;
  padding: 4px;
  pointer-events: none;
  backdrop-filter: blur(5px);
  background: rgba(0, 0, 0, 0.3);
`
